<script setup>
import { ref } from "vue"

import Layout from "../../layouts/main.vue"
import PageHeader from "@/components/page-header"

import FaqEditModal from "./FaqEditModal.vue"
import FaqsTable from "./FaqsTable.vue"

const title = "مدیریت پرسش و پاسخ"
const items = ref([
  {
    text: "داشبورد",
    href: "/",
  },
  {
    text: "مدیریت پرسش و پاسخ",
    active: true,
  },
])

const DEFAULT_FAQ = {
  id: "",
  question: "",
  answer: "",
  status: "",
}

const faqModel = ref({ ...DEFAULT_FAQ })
const showFaqEditModal = ref(false)

const showEditModal = () => {
  showFaqEditModal.value = true
}

const editFaq = (fq) => {
  faqModel.value = fq
  showEditModal()
}

const onModalClose = () => {
  faqModel.value = { ...DEFAULT_FAQ }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-row>
      <b-col lg="12">
        <b-card no-body id="faqList">
          <b-card-header class="border-bottom-dashed">
            <b-row class="g-4 align-items-center">
              <b-col sm>
                <div>
                  <h5 class="card-title mb-0">لیست پرسش و پاسخ</h5>
                </div>
              </b-col>
              <b-col sm="auto">
                <div class="d-flex flex-wrap align-items-start gap-2"></div>
              </b-col>
            </b-row>
          </b-card-header>

          <!-- faqs table  -->

          <FaqsTable @clickEdit="editFaq" />

          <!-- edit faq modal  -->

          <FaqEditModal
            v-model="showFaqEditModal"
            :faqProps="faqModel"
            @close="onModalClose"
          />
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>

<style>
.form-select {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9rem 0.5rem 2.7rem !important;
  background-position: left 0.9rem center !important;
}

.invalid-feedback {
  display: block !important;
}
</style>
